export default {
  Address: "Address",
  Street1: "Street number and name",
  Street2: "Street2",
  City: "City",
  County: "County",
  State: "State",
  ZipCode: "Zip Code",
  Contact: "Contact",
  MobilePhone: "Mobile Phone",
  HomePhone: "Home Phone",
  WorkPhone: "Work Phone",
  EmailAddress: "Email Address",
  FaxNumber: "Fax Number",
  PolicyCoverages: "Policy Coverages",
  LiabilityBiLimit: "Liability Bi Limit",
  LiabilityPdLimit: "Liability Pd Limit",
  MedPayLimit: "Med Pay Limit",
  UninsuredMotoristBiLimit: "Uninsured Motorist Bi Limit",
  UnderinsuredMotoristBiLimit: "Underinsured Motorist Bi Limit",
  AccidentalDeathLimit: "Accidental Death Limit",
  VehicleCoverages: "Vehicle Coverages",
  CollisionDeductible: "Collision Deductible",
  ComprehensiveDeductible: "Comprehensive Deductible",
  CustomEquipmentValue: "Custom Equipment Value",
  GapCoverage: "Gap Coverage",
  RentalLimit: "Rental Limit",
  TowingLimit: "Towing Limit",
  SafetyGlassCoverage: "Safety Glass Coverage",
  Customer: "Customer",
  Identifier: "Identifier",
  FirstName: "First Name",
  MiddleName: "Middle Name",
  LastName: "Last Name",
  DeclinedEmail: "Declined Email",
  DeclinedPhone: "Declined Phone",
  PriorAddress: "Prior Address",
  ContactInformation: "Contact Information",
  MonthsAtResidence: "Months At Residence",
  CustomerDeclinedCredit: "Customer Declined Credit",
  NumberOfResidentsInHousehold: "Number Of Residents In Household",
  PriorInsuranceInformation: "Prior Insurance Information",
  Discounts: "Discounts",
  CompanionPolicies: "Companion Policies",
  DistantStudent: "Distant Student",
  DriversTraining: "Drivers Training",
  GoodStudent: "Good Student",
  SingleParent: "Single Parent",
  AccidentPrevention: "Accident Prevention",
  AccidentPreventionCourseDate: "Accident Prevention Course Date",
  SeniorDriverDiscount: "Senior Driver Discount",
  SeniorDriverCourseDate: "Senior Driver Course Date",
  MultiplePolicies: "Multiple Policies",
  CompanionPolicy: "Companion Policy",
  LineOfBusiness: "Line Of Business",
  Driver: "Driver",
  DriverId: "Driver Id",
  DateOfBirth: "Date Of Birth",
  Gender: "Gender",
  MaritalStatus: "Marital Status",
  MonthsEmployed: "Months Employed",
  IndustryOccupation: "Industry Occupation",
  LicenseInformation: "License Information",
  Attributes: "Attributes",
  FinancialResponsibilityInformation: "Financial Responsibility Information",
  Violations: "Violations",
  DriverAttributes: "Driver Attributes",
  EducationLevel: "Education Level",
  OccasionalOperator: "Occasional Operator",
  PropertyInsurance: "Property Insurance",
  Relation: "Relation",
  ResidencyStatus: "Residency Status",
  ResidencyType: "Residency Type",
  MilesToWork: "Miles To Work",
  DriverLicenseInformation: "Driver License Information",
  LicenseStatus: "License Status",
  LicenseNumber: "License Number",
  MonthsForeignLicense: "Months Foreign License",
  MonthsLicensed: "Months Licensed",
  MonthsStateLicensed: "Months State Licensed",
  MonthsMvrExperience: "Months Mvr Experience",
  MonthsSuspended: "Months Suspended",
  StateLicensed: "State Licensed",
  CountryOfOrigin: "Country Of Origin",
  ForeignNational: "Foreign National",
  InternationalDriversLicense: "International Drivers License",
  Sr22: "Sr22",
  Sr22Reason: "Sr22 Reason",
  Sr22State: "Sr22 State",
  Sr22Date: "Sr22 Date",
  SR22CaseNumber: "S R22 Case Number",
  LienholderInformation: "Lienholder Information",
  LienHolderName: "Lien Holder Name",
  PhoneNumber: "Phone Number",
  LienHolderType: "Lien Holder Type",
  MiscellaneousFee: "Miscellaneous Fee",
  Amount: "Amount",
  ApplyToDownPayment: "Apply To Down Payment",
  Description: "Description",
  PercentOfTotalAmount: "Percent Of Total Amount",
  Type: "Type",
  Phone: "Phone",
  Number: "Number",
  Extension: "Extension",
  CustomerHasPriorWithThisAgency: "Customer Has Prior With This Agency",
  PriorCarrierId: "Prior Carrier Id",
  PriorCarrierName: "Prior Carrier Name",
  PriorExpirationDate: "Prior Expiration Date",
  PriorInsurance: "Prior Insurance",
  PriorLiabilityLimit: "Prior Liability Limit",
  PriorMonthsCoverage: "Prior Months Coverage",
  ReasonForNoInsurance: "Reason For No Insurance",
  Vehicle: "Vehicle",
  VehicleId: "Vehicle Id",
  ActualCashValue: "Actual Cash Value",
  AnnualMiles: "Annual Miles",
  AssignedDriverId: "Assigned Driver Id",
  CoverageInformation: "Coverage Information",
  GaragingAddress: "Garaging Address",
  GrayMarket: "Gray Market",
  HomingDevice: "Homing Device",
  HoodLock: "Hood Lock",
  LeasedVehicle: "Leased Vehicle",
  LicensePlateNumber: "License Plate Number",
  Odometer: "Odometer",
  PercentToWork: "Percent To Work",
  PurchaseCost: "Purchase Cost",
  PurchaseDate: "Purchase Date",
  PurchaseType: "Purchase Type",
  RideShare: "Ride Share",
  Salvaged: "Salvaged",
  Usage: "Usage",
  UsageBased: "Usage Based",
  Vin: "Vin",
  VinEtching: "Vin Etching",
  Violation: "Violation",
  Attribute1: "Attribute1",
  Attribute2: "Attribute2",
  Code: "Code",
  OccurredAt: "Occurred At",
  OccurredOnSameDayAsAnotherViolation:
    "Occurred On Same Day As Another Violation",
  BumpLimits: "Bump Limits",
  CarrierInformation: "Carrier Information",
  UseExactCarrierInfo: "Use Exact Carrier Info",
  Products: "Products",
  CarrierProduct: "Carrier Product",
  AgencyId: "Agency Id",
  CarrierId: "Carrier Id",
  CarrierName: "Carrier Name",
  ProductId: "Product Id",
  ProgramId: "Program Id",
  ProductName: "Product Name",
  ProductQuestions: "Product Questions",
  ProducerCode: "Producer Code",
  SubProducerCode: "Sub Producer Code",
  CarrierUserName: "Carrier User Name",
  CarrierPassword: "Carrier Password",
  CarrierQuoteNumber: "Carrier Quote Number",
  PolicyType: "Policy Type",
  MiscellaneousFees: "Miscellaneous Fees",
  RatedDrivers: "Rated Drivers",
  ExcludedDrivers: "Excluded Drivers",
  Vehicles: "Vehicles",
  Term: "Term",
  PaymentMethod: "Payment Method",
  NumberOfPayments: "Number Of Payments",
  DownPaymentPercentage: "Down Payment Percentage",
  PaperlessDiscount: "Paperless Discount",
  PaymentFilter: "Payment Filter",
  AgencyBill: "Agency Bill",
  EffectiveDate: "Effective Date",
  UninsuredMotoristPdLimit: "Uninsured Motorist Pd Limit",
  LegalExpense: "Legal Expense",
  ExpiredLicense: "Expired License",
  LearnersPermit: "Learners Permit",
  Licensed: "Licensed",
  SuspendedLicense: "Suspended License",
  RevokedLicense: "Revoked License",
  UninsuredMotoristPdDeductible: "Uninsured Motorist Pd Deductible",
  StackedUninsuredMotorist: "Stacked Uninsured Motorist",
  RoadsideLimit: "Roadside Limit",
  Sr22A: "Sr22 A",
  PipLimit: "Pip Limit",
  PrimaryFRPolicy: "Primary F R Policy",
};
